import Box from '@component/Box';
import Button from '@component/buttons/Button';
import { useRouter } from 'next/router';
import React, { Fragment, useEffect, useState } from 'react';
import Typography from '../Typography';
import FlexBox from '../FlexBox';
import Icon from '../icon/Icon';
import { DashboardNavigationWrapper, StyledDashboardNav } from './DashboardStyle';
import { signOut, useSession } from 'next-auth/react';
import SidebarApi from 'pages/api/sidebar';

const DashboardNavigation = () => {
  const { pathname } = useRouter();
  const { data: session, status } = useSession();
 const loading = status === 'loading';;
  const userId = session?.userId;
  const {
    getUserListings,
    getUserSales,
    getUserOrders,
    getUserWishLists,
    getUserTickets,
    getUserMessages,
    getUserAddresses,
  } = SidebarApi;
  const [listings, setListings] = useState(0);
  const [sales, setSales] = useState(0);
  const [purchases, setPurchases] = useState(0);
  const [wishlists, setWishlists] = useState(0);
  const [tickets, setTickets] = useState(0);
  const [messages, setMessages] = useState(0);
  const [addresses, setAddresses] = useState(0);

  useEffect(() => {
    const token = session?.accessToken?.toString();
    if (!loading) {
      (async () => {
        const listingsData = await getUserListings(token, userId);
        const salesData = await getUserSales(token);
        const purchasesData = await getUserOrders(token);
        const wishlistsData = await getUserWishLists(token);
        const ticketsData = await getUserTickets(token);
        const messagesData = await getUserMessages(token);
        const addressesData = await getUserAddresses(token);

        setMessages(messagesData?.data.length);
        setListings(listingsData?.data.total);
        setSales(salesData?.data.total);
        setPurchases(purchasesData?.data.total);
        setWishlists(wishlistsData?.data.total);
        setTickets(ticketsData?.data.total);
        setAddresses(addressesData?.data.length);
      })();
    }
  }, [loading]);

  const linkList = [
    {
      title: 'MY SALES',
      list: [
        {
          href: '/vendor/listings',
          title: 'Listings',
          iconName: 'box',
          count: listings,
        },
        {
          href: '/vendor/add-listing',
          title: 'Create New Listing',
          iconName: 'upload',
        },
        {
          href: '/vendor/sales',
          title: 'Sales',
          iconName: 'bag',
          count: sales,
        },
      ],
    },
    {
      title: 'MY PURCHASES',
      list: [
        {
          href: '/orders',
          title: 'Purchases',
          iconName: 'shopping-cart',
          count: purchases,
        },
        {
          href: '/wish-list',
          title: 'Wishlist',
          iconName: 'heart',
          count: wishlists,
        },
        {
          href: '/support-tickets',
          title: 'Support Tickets',
          iconName: 'customer-service',
          count: tickets,
        },
      ],
    },
    {
      title: 'ACCOUNT',
      list: [
        {
          href: '/profile',
          title: 'Profile Overview',
          iconName: 'user',
        },
        {
          href: '/profile/messages',
          title: 'Messages',
          iconName: 'mail',
          count: messages,
        },
        {
          href: '/vendor/account-settings',
          title: 'Sellers Settings',
          iconName: 'gear-2',
        },
        {
          href: '/address',
          title: 'Addresses',
          iconName: 'pin',
          count: addresses,
        },
        // {
        //   href: '/payment-methods',
        //   title: 'Payment Methods',
        //   iconName: 'credit-card',
        //   count: payments,
        // },
      ],
    },

    // {
    //   href: '/vendor/orders',
    //   title: 'Orders',
    //   iconName: 'shopping-cart',
    //   count: 40,
    // },
    // {
    //   href: '/vendor/account-settings',
    //   title: 'Account Settings',
    //   iconName: 'gear-2',
    // },
    // {
    //   href: '/vendor/account-settings',
    //   title: 'Support Tickets',
    //   iconName: 'support',
    // },
  ];

  return (
    <DashboardNavigationWrapper px="0px" py="1.5rem" color="gray.900">
      {linkList.map((item: any): any => (
        <Fragment key={item.title}>
          <Typography p="26px 30px 1rem" color="text.muted" fontSize="12px">
            {item.title}
          </Typography>
          {item.list.map((item) => (
            <StyledDashboardNav
              isCurrentPath={pathname.includes(item.href)}
              href={item.href}
              key={item.title}
              px="1.5rem"
              mb="1.25rem"
            >
              <FlexBox alignItems="center">
                <Box className="dashboard-nav-icon-holder">
                  <Icon variant="small" defaultcolor="currentColor" mr="10px">
                    {item.iconName}
                  </Icon>
                </Box>
                <span>{item.title}</span>
              </FlexBox>
              <span>{item.count}</span>
            </StyledDashboardNav>
          ))}
        </Fragment>
      ))}
      <FlexBox alignItems="center" justifyContent="center" px="1.5rem" pt="2rem">
        <Button
          variant="contained"
          color="primary"
          px="2rem"
          onClick={() => signOut({ callbackUrl: '/' })}
        >
          Log Out
        </Button>
      </FlexBox>
    </DashboardNavigationWrapper>
  );
};


export default DashboardNavigation;
